<div class="content">
    <div class="row items-push">
        <div class="col-sm-12 text-left">
            <ol class="breadcrumb push-10-t">
                <li><a [routerLink]="['/']">Inicio</a></li>
                <li><span class="link-effect">Información SSO</span></li>
                <li><span class="link-effect">Calendario</span></li>
            </ol>
        </div>
    </div>
  </div>
  
  <div class="content">
    <div class="block">
      <div class="block-header">
        <h3 class="block-title">Calendario Información SSO</h3>
    </div>
    
  
  <div class="block-content">
    <div class="form-horizontal">
      <div class="form-group">
        <label class="col-md-1 control-label">Compañía:</label>
        <div class="col-md-3">
          <mat-form-field appearance="outline">
            <mat-label> Seleccione: </mat-label>
            <mat-select matSelect [(ngModel)]="model.idCompania" (selectionChange)="anioChanged($event)" [disabled]="listaCompanias.length == 1">
              <mat-option *ngFor="let company of listaCompanias" [value]="company.idCompania">
                {{ company.nombre }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <label class="col-md-1 control-label">Año:</label>
        <div class="col-md-2">
          <mat-form-field appearance="outline">
            <mat-label>
              Seleccione
            </mat-label>
            <mat-select matSelect [(ngModel)]="model.anio"
            (selectionChange)="anioChanged($event)" >
              <mat-option *ngFor="let item of listaAnios; index as i;" [value]='item'>{{item}}</mat-option>
            </mat-select>
          </mat-form-field>   
        </div>  
        <div class="col-md-1">
          <button type="button" class="btn btn-naranja2" mat-button  (click)="generarCalendario()"><mat-icon>create</mat-icon> Generar Calendario {{anioSiguiente}}</button>
        </div>
        <div class="col-md-4"></div>
        <!-- <label class="col-md-1 control-label">Fecha Prueba:</label>
        <div class="col-md-2">
          <mat-form-field appearance="outline" hideRequiredMarker>
            <mat-label>Fecha Prueba</mat-label>
            <input
              matInput
              [matDatepicker]="pckrfechaPrueba"
              [(ngModel)]="fechaPrueba"
              id="fechaPrueba"
              name="fechaPrueba"
              required
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="pckrfechaPrueba"
            ></mat-datepicker-toggle>
            <mat-datepicker #pckrfechaPrueba></mat-datepicker>
          </mat-form-field>
        </div>   
        <div class="col-md-1">
          <button type="button" class="btn btn-naranja2" mat-button  (click)="updateFechaPrueba()"><mat-icon>create</mat-icon> Actualizar</button>
        </div>            -->
    </div>
  
    <!-- <div class="form-horizontal">
      <div class="form-group">
          <div class="col-sm-6 text-left">
            <a class="btn btn-naranja" mat-raised-button [routerLink]="['/configuracion', 'sedes', 'registrar']"><mat-icon>description</mat-icon> Nueva Sede</a>
          </div>
          <div class="col-sm-6 text-right">
            <a class="btn btn-cyan" mat-raised-button (click)="search()" ><mat-icon>search</mat-icon> Buscar</a>
          </div>
      </div>
    </div> -->
    <div class="table-responsive">
      <table mat-table [dataSource]="listaCalendario" class="table table-striped table-vcenter">
          <ng-container matColumnDef="mes">
            <th mat-header-cell *matHeaderCellDef>Mes</th>
            <td mat-cell *matCellDef="let element">{{ element.nombreMes }}</td>
          </ng-container>
      
          <ng-container matColumnDef="fechaNotificacion">
            <th mat-header-cell *matHeaderCellDef>Fecha Notificación</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.fechaNotificacion | date:'dd/MM/yyyy'}}</td>
          </ng-container>
      
          <ng-container matColumnDef="fechaInicio">
            <th mat-header-cell *matHeaderCellDef>Fecha Inicio</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.fechaInicio | date:'dd/MM/yyyy'}}</td>
          </ng-container>
      
          <ng-container matColumnDef="fechaFin">
            <th mat-header-cell *matHeaderCellDef>Fecha Fin</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.fechaFin | date:'dd/MM/yyyy'}}</td>
          </ng-container>
      
          <ng-container matColumnDef="fechaCierre">
            <th mat-header-cell *matHeaderCellDef>Fecha Cierre</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.fechaCierre | date:'dd/MM/yyyy'}}</td>
          </ng-container>
      
          <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let element"> 
                <button type="button" mat-icon-button color="primary" (click)="openDialogCalendario(element)" *ngIf="element.editable" aria-label="Editar">
                  <mat-icon>create</mat-icon>
                </button>
                <!-- <a mat-icon-button color="primary" aria-label="Editar" [routerLink]="['/sso/', 'registrar']" *ngIf="element.editable">
                  <mat-icon>create</mat-icon>
                </a> -->
              </td>
            </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      
        </table>  

        <!-- <mat-paginator #paginator [length]="resultsLength" [pageSize]="30" 
              (page)="getPaginatorData($event)"
              [pageSizeOptions]="[30, 50, 100]"></mat-paginator> -->
      </div>
  
    </div>
  </div>
  </div>